import { Injectable, signal, WritableSignal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  approveAgentRequest,
  fetchAgentRequestDetail,
  fetchAgentsRequestsList,
  rejectAgentRequest,
} from 'src/app/store/agents-requests/agents-requests.action';
import {
  agentRequestDetailPayload,
  agentsRequestsListPayload,
  approveRejectAgentRequestPayload,
} from 'src/app/store/agents-requests/agents-requests.model';
import {
  selectAgentReqeustDetail,
  selectAgentsRequestsDataLoading,
  selectAgentsRequestsList,
  selectAgentsRequestsPagination,
} from 'src/app/store/agents-requests/agents-requests.selector';
import {
  activeDeactiveAgent,
  fetchAgentsList,
} from 'src/app/store/agents/agents.action';
import {
  activeDeactiveAgentPayload,
  agentsListPayload,
} from 'src/app/store/agents/agents.model';
import {
  selectActiveAgentsList,
  selectAgentsDataLoading,
  selectAgentsList,
  selectAgentsPagination,
} from 'src/app/store/agents/agents.selector';
import {
  fetchAris360List,
  fetchAris360Detail,
  assignAgent,
} from 'src/app/store/aris360/aris360.action';
import {
  aris360DetailPayload,
  aris360ListPayload,
} from 'src/app/store/aris360/aris360.model';
import {
  selectAris360List,
  selectAris360Pagination,
  selectAris360Detail,
  selectAris360DataLoading,
} from 'src/app/store/aris360/aris360.selector';
import {
  addUpdateBlog,
  deleteBlog,
  fetchBlogsDetail,
  fetchBlogsList,
} from 'src/app/store/Blogs/blogs.action';
import {
  blogsDetailPayload,
  blogsListPayload,
} from 'src/app/store/Blogs/blogs.model';
import {
  selectBlogsDataLoading,
  selectBlogsDetail,
  selectBlogsList,
  selectBlogsPagination,
} from 'src/app/store/Blogs/blogs.selector';
import {
  fetchDashboardCardsData,
  fetchDashboardGraphStatsData,
} from 'src/app/store/dashboards/dashboard.action';
import {
  selectDashboardCardsData,
  selectDashboardCardsDataLoading,
  selectDashboardGraphStatsData,
  selectDashboardGraphStatsDataLoading,
} from 'src/app/store/dashboards/dashboard.selector';
import {
  changePassword,
  fetchAdminProfileData,
  updateAdminProfile,
  updateAdminProfileImage,
} from 'src/app/store/layouts/layout-action';
import { SelectAdminProfileData } from 'src/app/store/layouts/layout-selector';
import {
  assignAgentLead,
  fetchLeadsList,
} from 'src/app/store/Leads/leads.action';
import { leadsListPayload } from 'src/app/store/Leads/leads.model';
import {
  selectLeadsDataLoading,
  selectLeadsList,
  selectLeadsPagination,
} from 'src/app/store/Leads/leads.selector';
import {
  fetchNwmlsDetail,
  fetchNwmlsList,
} from 'src/app/store/nwmls/nwmls.action';
import {
  nwmlsDetailPayload,
  nwmlsListPayload,
} from 'src/app/store/nwmls/nwmls.model';
import {
  selectNwmlsDataLoading,
  selectNwmlsDetail,
  selectNwmlsList,
  selectNwmlsPagination,
} from 'src/app/store/nwmls/nwmls.selector';
import { subscribersListPayload } from 'src/app/store/subscribers/subscriber.model';
import {
  selectSubscribersList,
  selectSubscribersPagination,
  selectSubscribersDataLoading,
} from 'src/app/store/subscribers/subscriber.selector';
import { fetchSubscribersList } from 'src/app/store/subscribers/subscribers.action';
import { fetchSupportTicketsList, fetchSupportTicketsDetail, assignAgentTicket, updateTicketStatus, ticketCards, fetchSupportTicketsReplays, sendSupportTicketReply } from 'src/app/store/support-tickets/support-tickets.actions';
import { supportTicketsListPayload, supportTicketsDetailPayload, supportTicketsReplaysPayload } from 'src/app/store/support-tickets/support-tickets.model';
import { selectSupportTicketsList, selectSupportTicketsPagination, selectSupportTicketsDetail, selectSupportTicketsDataLoading, selectTicketCards, selectSupportTicketsReplaysError, selectSupportTicketsReplays } from 'src/app/store/support-tickets/support-tickets.selector';
import { activeDeactiveUser, fetchUsersList } from 'src/app/store/users/users.action';
import { activeDeactiveUserPayload, usersListPayload } from 'src/app/store/users/users.model';
import { selectUsersList, selectUsersPagination, selectUsersDataLoading } from 'src/app/store/users/users.selector';
import { SendMessageRequest } from './signal-r.service';
import {
  addMessage,
  loadChatUsers,
  loadMessages,
  sendMessage,
  setCurrentChatUser,
} from 'src/app/store/chats/chats.action';
import { Agent } from 'src/app/store/chats/chats.model';
import {
  selectChatError,
  selectChatLoading,
  selectChatUsers,
  selectCurrentChatUser,
  selectMessages,
} from 'src/app/store/chats/chats.selector';
import {
  ISearchRequest,
  PayrollSubmissions,
  UpdateAgentPayrollStatus,
} from 'src/app/store/Authentication/auth.models';
import {
  getAgentPayrollSubmissionDetails,
  getAgentPayrollSubmissionDetailsSuccess,
  getAgentPayrollSubmissions,
  updateAgentPayrollSubmissionStatus,
} from 'src/app/store/Authentication/authentication.actions';
import {
  selectAgentPayrollSubmissionDetails,
  selectAgentPayrollSubmissions,
  selectIsLoading,
  selectPaginationData,
} from 'src/app/store/Authentication/authentication-selector';

@Injectable({
  providedIn: 'root',
})
export class AuthFacadeService {
  constructor(private store: Store) {}

  isLoading$ = this.store.select(selectIsLoading);
  paginationData$ = this.store.select(selectPaginationData);
  agentPayrollSubmissions$ = this.store.select(selectAgentPayrollSubmissions);
  agentPayrollSubmissionDetails$ = this.store.select(
    selectAgentPayrollSubmissionDetails
  );

  // profile
  profile$ = this.store.select(SelectAdminProfileData);

  getProfile() {
    this.store.dispatch(fetchAdminProfileData());
  }

  updateAdminProfileImage(data: any) {
    this.store.dispatch(updateAdminProfileImage({ payload: data }));
  }

  updateAdminProfile(data: any) {
    this.store.dispatch(updateAdminProfile({ payload: data }));
  }

  changePssword(data: any) {
    this.store.dispatch(changePassword({ payload: data }));
  }

  // nwmls
  fetchNwmls$ = this.store.select(selectNwmlsList);
  fetchNwmlsPagination$ = this.store.select(selectNwmlsPagination);
  fetchNwmlsDetail$ = this.store.select(selectNwmlsDetail);
  loadingNwmls$ = this.store.select(selectNwmlsDataLoading);

  getNwmls(data: nwmlsListPayload) {
    this.store.dispatch(fetchNwmlsList({ payload: data }));
  }

  getNwmlsDetail(id: nwmlsDetailPayload) {
    this.store.dispatch(fetchNwmlsDetail({ payload: id }));
  }

  // blogs
  fetchBlogs$ = this.store.select(selectBlogsList);
  fetchBlogsPagination$ = this.store.select(selectBlogsPagination);
  loadingBlogs$ = this.store.select(selectBlogsDataLoading);
  fetchBlogsDetail$ = this.store.select(selectBlogsDetail);

  addUpdateBlog(data: any) {
    this.store.dispatch(addUpdateBlog({ payload: data }));
  }

  getBlogs(data: blogsListPayload) {
    this.store.dispatch(fetchBlogsList({ payload: data }));
  }

  getBlogsDetail(id: blogsDetailPayload) {
    this.store.dispatch(fetchBlogsDetail({ payload: id }));
  }

  deleteBlog(id: any) {
    this.store.dispatch(deleteBlog({ payload: id }));
  }

  // leads
  fetchLeads$ = this.store.select(selectLeadsList);
  fetchLeadsPagination$ = this.store.select(selectLeadsPagination);
  loadingLeads$ = this.store.select(selectLeadsDataLoading);

  getLeads(data: leadsListPayload) {
    this.store.dispatch(fetchLeadsList({ payload: data }));
  }

  // subscribers
  fetchSubscribers$ = this.store.select(selectSubscribersList);
  fetchSubscribersPagination$ = this.store.select(selectSubscribersPagination);
  loadingSubscribers$ = this.store.select(selectSubscribersDataLoading);

  getSubscribers(data: subscribersListPayload) {
    this.store.dispatch(fetchSubscribersList({ payload: data }));
  }

  // users
  fetchUsers$ = this.store.select(selectUsersList);
  fetchUsersPagination$ = this.store.select(selectUsersPagination);
  loadingUsers$ = this.store.select(selectUsersDataLoading);

  getUsers(data: usersListPayload) {
    this.store.dispatch(fetchUsersList({ payload: data }));
  }

  activeDeactiveUser(data: activeDeactiveUserPayload) {
    this.store.dispatch(activeDeactiveUser({ payload: data }));
  }

  // agents
  fetchAgents$ = this.store.select(selectAgentsList);
  fetchAgentsPagination$ = this.store.select(selectAgentsPagination);
  loadingAgents$ = this.store.select(selectAgentsDataLoading);
  fetchActiveAgents$ = this.store.select(selectActiveAgentsList);

  getAgents(data: agentsListPayload) {
    this.store.dispatch(fetchAgentsList({ payload: data }));
  }

  activeDeactiveAgent(data: activeDeactiveAgentPayload) {
    this.store.dispatch(activeDeactiveAgent({ payload: data }));
  }

  // aris360
  fetchAris360$ = this.store.select(selectAris360List);
  fetchAris360Pagination$ = this.store.select(selectAris360Pagination);
  fetchAris360Detail$ = this.store.select(selectAris360Detail);
  loadingAris360$ = this.store.select(selectAris360DataLoading);

  getAris360(data: aris360ListPayload) {
    this.store.dispatch(fetchAris360List({ payload: data }));
  }

  getAris360Detail(id: aris360DetailPayload) {
    this.store.dispatch(fetchAris360Detail({ payload: id }));
  }

  assignToAgent(data: any) {
    this.store.dispatch(assignAgent({ payload: data }));
  }

  // support tickets
  fetchSupportTickets$ = this.store.select(selectSupportTicketsList);
  fetchSupportTicketsPagination$ = this.store.select(
    selectSupportTicketsPagination
  );
  fetchSupportTicketsDetail$ = this.store.select(selectSupportTicketsDetail);
  loadingSupportTickets$ = this.store.select(selectSupportTicketsDataLoading);
  fetchSupportTicketCards$ = this.store.select(selectTicketCards);
  fetchSupportTicketsReplays$ = this.store.select(selectSupportTicketsReplays)

  getSupportTickets(data: supportTicketsListPayload) {
    this.store.dispatch(fetchSupportTicketsList({ payload: data }));
  }

  getSupportTicketsDetail(id: supportTicketsDetailPayload) {
    this.store.dispatch(fetchSupportTicketsDetail({ payload: id }));
  }

  assignToAgentTicket(data: any) {
    this.store.dispatch(assignAgentTicket({ payload: data }));
  }

  updateTicketStatus(data: any) {
    this.store.dispatch(updateTicketStatus({ payload: data }));
  }

  getSupportTicketCards() {
    this.store.dispatch(ticketCards());
  }

  getSupportTicketReplays(id: supportTicketsReplaysPayload) {
    this.store.dispatch(fetchSupportTicketsReplays({ticketId: id}))
  }

  sendSupportTicketReply(ticketId: number, message: string, image?: File) {
    const formData = new FormData();
    formData.append('TicketId', ticketId.toString());
    formData.append('Message', message);
    if (image) {
      formData.append('Image', image);
    }
    this.store.dispatch(sendSupportTicketReply({ formData }));
  }

  // dashboard
  fetchDashboardCards$ = this.store.select(selectDashboardCardsData);
  loadingDashboardCards$ = this.store.select(selectDashboardCardsDataLoading);
  fetchDashboardGraphStats$ = this.store.select(selectDashboardGraphStatsData);
  loadingDashboardGraphStats$ = this.store.select(
    selectDashboardGraphStatsDataLoading
  );

  getDashboardCards() {
    this.store.dispatch(fetchDashboardCardsData());
  }

  assignToAgentLead(data: any) {
    this.store.dispatch(assignAgentLead({ payload: data }));
  }

  getDashboardGraphStats() {
    this.store.dispatch(fetchDashboardGraphStatsData());
  }

  // agents requests
  fetchAgentsRequests$ = this.store.select(selectAgentsRequestsList);
  fetchAgentsRequestsPagination$ = this.store.select(
    selectAgentsRequestsPagination
  );
  fetchAgentReqeustDetail$ = this.store.select(selectAgentReqeustDetail);
  loadingAgentsRequests$ = this.store.select(selectAgentsRequestsDataLoading);

  getAgentsRequests(data: agentsRequestsListPayload) {
    this.store.dispatch(fetchAgentsRequestsList({ payload: data }));
  }

  getAgentReqeustDetail(id: agentRequestDetailPayload) {
    this.store.dispatch(fetchAgentRequestDetail({ payload: id }));
  }

  approveAgentRequest(data: approveRejectAgentRequestPayload) {
    this.store.dispatch(approveAgentRequest({ payload: data }));
  }

  rejectAgentRequest(data: approveRejectAgentRequestPayload) {
    this.store.dispatch(rejectAgentRequest({ payload: data }));
  }

  //chats
  agentDetail: WritableSignal<Agent | null> = signal<Agent | null>(null);
  chatUsers$ = this.store.select(selectChatUsers);
  currentChatUser$ = this.store.select(selectCurrentChatUser);
  messages$ = this.store.select(selectMessages);
  chatLoading$ = this.store.select(selectChatLoading);
  chatError$ = this.store.select(selectChatError);
  usersLoading$ = this.store.select((state: any) => state.chats.usersLoading);
  messagesLoading$ = this.store.select(
    (state: any) => state.chats.messagesLoading
  );

  loadChatUsers(id: number): void {
    this.store.dispatch(loadChatUsers({ id }));
  }

  loadMessages(senderId: number, receiverId: number): void {
    this.store.dispatch(loadMessages({ senderId, receiverId }));
  }

  sendMessage(message: SendMessageRequest): void {
    this.store.dispatch(sendMessage({ message }));
  }

  setCurrentChatUser(user: any): void {
    // Always dispatch a new object to force store update
    const newUser = { ...user };
    console.log('[AuthFacadeService] setCurrentChatUser:', newUser);
    this.store.dispatch(setCurrentChatUser({ user: newUser }));
  }

  addIncomingMessage(message: SendMessageRequest): void {
    this.store.dispatch(addMessage({ message }));
  }

  // Agent detail management
  setAgentDetail(agent: any): void {
    try {
      this.agentDetail.set(agent);
      console.log(
        '[AuthFacadeService] agentDetail signal value after set:',
        this.agentDetail()
      );
    } catch (error) {
      console.error('[AuthFacadeService] Error setting agent detail:', error);
    }
  }

  clearAgentDetail(): void {
    console.log('[AuthFacadeService] clearAgentDetail called');
    try {
      this.agentDetail.set(null);
    } catch (error) {
      console.error('[AuthFacadeService] Error clearing agent detail:', error);
    }
  }

  // Helper method to get current agent detail
  getAgentDetail(): Agent | null {
    try {
      const agent = this.agentDetail();
      return agent;
    } catch (error) {
      console.error('[AuthFacadeService] Error getting agent detail:', error);
      return null;
    }
  }

  // Method to check if agent detail signal is available
  isAgentDetailSignalAvailable(): boolean {
    try {
      return this.agentDetail !== undefined && this.agentDetail !== null;
    } catch (error) {
      console.error(
        '[AuthFacadeService] Error checking agent detail signal availability:',
        error
      );
      return false;
    }
  }

  getAgentPayrollSubmissions(data: ISearchRequest) {
    this.store.dispatch(getAgentPayrollSubmissions({ data }));
  }

  getPayrollSubmissionDetails(id: number) {
    this.store.dispatch(getAgentPayrollSubmissionDetails({ id }));
  }

  updateAgentPayrollSubmissionStatus(data: UpdateAgentPayrollStatus) {
    this.store.dispatch(updateAgentPayrollSubmissionStatus({ data }));
  }

  setPayrollSubmission(data: PayrollSubmissions) {
    this.store.dispatch(getAgentPayrollSubmissionDetailsSuccess({ data }));
  }
}
